module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms1ax"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms1axIndex,
      "columnEvent": _vm.columnEvent,
      "maxRowspan": _vm.maxRowspan.index,
      "csvExportDisp": true,
      "searchBoxAlias": "hrms1ax",
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10916a7f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms1ax/component.vue
// module id = 3563
// module chunks = 1